import {NgModule} from '@angular/core';

import {SummernoteComponent} from './summernote.component';

@NgModule({
    declarations:[
        SummernoteComponent
    ],
    exports:[
        SummernoteComponent
    ]
})
export class SummernoteModule{

}